import { MicNoneOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import { keyframes, useTheme } from "@mui/system"
import { useEffect } from "react";

const pulseAnimation = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 0.9; }
  100% { transform: scale(1); opacity: 0.7; }
`

const pulseAnimation2 = keyframes`
  0% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.7; }
  100% { transform: scale(1); opacity: 0.5; }
`

interface CustomButtonProps {
    isRecording: boolean;
}

const MicWithAnimation: React.FC<CustomButtonProps> = ({ isRecording }) => {
    const theme = useTheme()
    useEffect(() => {
        console.log("MicWithAnimation isRecording", isRecording)
    }, [isRecording])

    return (
        <Box
            sx={{
                position: "relative",
                width: 250,
                height: 250,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    bgcolor: "primary.light",
                    opacity: 0.3,
                    animation: isRecording ? `${pulseAnimation2} 2s infinite` : "none",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    width: "90%",
                    height: "90%",
                    borderRadius: "50%",
                    bgcolor: "primary.light",
                    opacity: 0.5,
                    animation: isRecording ? `${pulseAnimation} 2s infinite` : "none",
                }}
            />
            <Box
                sx={{
                    width: "80%",
                    height: "80%",
                    borderRadius: "50%",
                    bgcolor: theme.palette.background.default,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1,
                }}
            >
                <MicNoneOutlined sx={{ fontSize: 80, color: "text.secondary" }} />
            </Box>
        </Box>
    )
}

export default MicWithAnimation;